var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabLoginIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lab-login-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.668,
    height: 128,
    viewBox: "0 0 98.668 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M283.769,30.217a3.732,3.732,0,0,0,2.148-.679l12.285-8.6a3.75,3.75,0,0,0,.92-5.223L289.235,1.6A3.75,3.75,0,0,0,284.012.68l-12.285,8.6a3.75,3.75,0,0,0-.92,5.223l9.887,14.11A3.745,3.745,0,0,0,283.769,30.217Z",
    transform: "translate(-253.998 -0.001)",
    fill: "#1a82c7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M317.07,44.6a3.749,3.749,0,0,1-5.223-.92l-9.887-14.111a3.75,3.75,0,0,1,.92-5.223l6.086-4.263,14.2,20.247Z",
    transform: "translate(-285.152 -15.062)",
    fill: "#176cad"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M153.591,218.494a3.75,3.75,0,0,0,3.069-5.9l-5.962-8.518a3.75,3.75,0,0,0-6.145,4.3l5.962,8.518a3.747,3.747,0,0,0,3.076,1.6Z",
    transform: "translate(-79.974 -151.857)",
    fill: "#125994"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M202.73,252.914a3.751,3.751,0,0,0,3.069-5.9l-5.962-8.518a3.75,3.75,0,0,0-6.145,4.3l5.962,8.518A3.747,3.747,0,0,0,202.73,252.914Z",
    transform: "translate(-141.396 -177.672)",
    fill: "#125994"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M184.806,104.7a3.732,3.732,0,0,0,2.148-.679l18.427-12.908a3.75,3.75,0,0,0,.919-5.225L180.688,49.37a3.75,3.75,0,0,0-5.222-.918L157.039,61.359a3.75,3.75,0,0,0-.919,5.224l25.612,36.524a3.746,3.746,0,0,0,3.073,1.6Z",
    transform: "translate(-132.506 -35.83)",
    fill: "#37a8e5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M230.392,125.53a3.749,3.749,0,0,1-5.222-.918L199.558,88.088a3.75,3.75,0,0,1,.919-5.225l9.163-6.418,29.918,42.665Z",
    transform: "translate(-175.944 -57.334)",
    fill: "#1a82c7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M168.327,163.016l10.643,15.2a25.534,25.534,0,1,0,18.571,34.035h15.644a40.537,40.537,0,1,1-44.858-49.239Z",
    transform: "translate(-133.135 -122.262)",
    fill: "#ff9300"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M326.394,163.016l5.342,7.631v7.018a25.533,25.533,0,0,0,0,51.067v15a40.535,40.535,0,0,1-5.341-80.716Z",
    transform: "translate(-291.202 -122.262)",
    fill: "#ff9300"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M62.415,352.471h47.5a3.75,3.75,0,1,0,0-7.5h-47.5a3.75,3.75,0,1,0,0,7.5Z",
    transform: "translate(-14.997 -258.729)",
    fill: "#2698d1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 8.75,
    cy: 8.75,
    r: 8.75,
    transform: "translate(31.784 38)",
    fill: "#2698d1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M253.7,162a12.5,12.5,0,1,0-12.5-12.5A12.514,12.514,0,0,0,253.7,162Zm0-17.5a5,5,0,1,1-5,5A5.006,5.006,0,0,1,253.7,144.5Z",
    transform: "translate(-213.17 -102.751)",
    fill: "#ffe645"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M180.25,436.154h49.99a3.75,3.75,0,0,0,3.6-4.811l-1.543-5.232a21.247,21.247,0,0,0-20.378-15.24H198.574a21.247,21.247,0,0,0-20.379,15.24l-1.543,5.232a3.75,3.75,0,0,0,3.6,4.811Z",
    transform: "translate(-164.781 -308.154)",
    fill: "#176cad"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M292.9,426.11a21.247,21.247,0,0,1,20.379-15.24h6.74v25.283H294.952a3.75,3.75,0,0,1-3.6-4.811Z",
    transform: "translate(-279.483 -308.153)",
    fill: "#125994"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabLoginIcon);
export default __webpack_public_path__ + "static/media/lab-login-icon.3850c59cec57e1a1eb9370ee268b4175.svg";
export { ForwardRef as ReactComponent };